import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Box from "./box";
import Checkbox from "./checkbox";
import Form from "./form";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";

export default function AcknowledgeCommitment() {
  const nextUrl = "/apply/personal-information/";
  const submitUrl = "/api/applications/v4/application/acknowledge_commitment/";
  const [form, setForm] = useState({ errors: null });
  const {
    data: {
      results: [{ requires_battery_powered } = { requires_battery_powered: false }]
    }
  } = useQuery(["application"]);
  if (requires_battery_powered) {
    return (
      <Page>
        <PageHeader title="membership application" tagline="Battery Powered">
          <P>
            By checking this box, I acknowledge that I was nominated for Battery membership under a
            special program focused on increasing charitable impact. If I am accepted to The
            Battery, I will be required to make a donation (starting at $4,000 per year) to Battery
            Powered for my first two years. This charitable gift is separate from my Club dues and
            gives me access to the Battery Powered membership program.
          </P>
        </PageHeader>
        <Form form={form} setForm={setForm} submitUrl={submitUrl} nextUrl={nextUrl}>
          <Box>
            <Checkbox
              label="I acknowledge"
              name="acknowledge_commitment_ind"
              form={form}
              setForm={setForm}
            />
          </Box>
        </Form>
      </Page>
    );
  }
  return <Redirect to={`/apply/personal-information`} />;
}
